import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { BridgeElement } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "menu"
  static targets = ["title", "item"]

  show(event) {
    if (this.enabled) {
      event.stopImmediatePropagation()
      this.notifyBridgeToDisplayMenu(event)
    }
  }

  haptic() {
    if (this.enabled) {
      this.send("haptic", {})
    }
  }

  notifyBridgeToDisplayMenu(event) {
    const title = new BridgeElement(this.titleTarget).title
    const items = this.makeMenuItems(this.itemTargets)
    const locale = document.documentElement.lang || "en"
    const { x, y, width, height } = event.target.getBoundingClientRect()

    // getBoundingClientRect returns CSS px in the layout viewport. On tablets
    // the viewport is pinned to a fixed width and zoomed up (see the tablet
    // upscale script in mobile.html.erb), so native points = CSS px × scale.
    // On phones scale is 1 and this is a no-op.
    const scale = window.visualViewport?.scale || 1

    // Opt-in placement override, read off the menu container. The overflow
    // pattern sets data-bridge-anchor="navbar" because its trigger is a 1px
    // relay parked in the page — its rect is meaningless, the button the user
    // tapped lives in the native nav bar. Menus that leave this unset send
    // undefined and native positions off the source rect exactly as before.
    const anchor = new BridgeElement(this.element).bridgeAttribute("anchor")

    const payload = {
      title,
      items,
      locale,
      anchor,
      source: {
        x: x * scale,
        y: y * scale,
        width: width * scale,
        height: height * scale
      }
    }

    this.send("display", payload, message => {
      const selectedIndex = message.data.selectedIndex
      const selectedItem = new BridgeElement(this.itemTargets[selectedIndex])

      selectedItem.click()
    })
  }

  makeMenuItems(elements) {
    const items = elements.map((element, index) => this.menuItem(element, index))
    const enabledItems = items.filter(item => item)

    return enabledItems
  }

  menuItem(element, index) {
    const bridgeElement = new BridgeElement(element)

    if (bridgeElement.disabled) return null

    return {
      title: bridgeElement.title,
      index: index,
      icon: bridgeElement.bridgeAttribute("ios-icon") || "",
      style: bridgeElement.bridgeAttribute("style") || "default"
    }
  }
}
